import { Size } from '@components/Templates/utils/types';
import cn from '@utils/cn';
import { buildTemplateUrl } from '@utils/urls';
import DesignClient from './DesignClient';
import DesignSet from './DesignSet/DesignSet';
import { DesignSetIdLayout } from './types';

export type DesignProps = {
  designSetLayout?: DesignSetIdLayout;
  sizes?: Size[];
  hash: string;
  name: string;
  hasAnimation?: boolean;
  className?: string;
  designTypeName?: string | null;
  isStaticFilterSelected?: boolean;
  description?: string;
};

export default function Design({
  designSetLayout,
  sizes,
  hash,
  name,
  designTypeName,
  hasAnimation,
  isStaticFilterSelected,
  className,
  description,
}: DesignProps) {
  const queryParams = isStaticFilterSelected ? '?isStatic=true' : '';
  const url = `${buildTemplateUrl(hash, name, designSetLayout?.layout)}${queryParams}`;
  const displayName = `${name} ${designTypeName ?? ''}`;

  function renderDesign() {
    if (!sizes?.length) {
      return null;
    }
    if (designSetLayout?.layout) {
      return (
        <DesignSet
          sizes={sizes}
          layout={designSetLayout.layout}
          name={displayName}
          description={description}
          url={url}
        />
      );
    }

    return (
      <DesignClient
        hash={hash}
        name={displayName}
        isAnimated={hasAnimation}
        url={url}
        width={sizes?.[0]?.width}
        height={sizes?.[0]?.height}
      />
    );
  }

  return (
    <div className={cn('col-span-2 break-inside-avoid sm:col-span-3 md:col-span-2 lg:col-span-3', className)}>
      {renderDesign()}
    </div>
  );
}

export function hasDesignAnimation(
  design: { hasAnimation?: boolean; hasVideo?: boolean },
  isStaticFilterSelected?: boolean,
) {
  return !isStaticFilterSelected && (design?.hasAnimation || design?.hasVideo);
}
